import { isHiddenPlansOnly, serverPricingToClientPriceAndCurrencyString, serverPricingToClientPriceAndCurrencyStringV3, } from './pp';
export const serverPricingToClientPrice = (serverPricing) => {
    if (!serverPricing || !serverPricing.singlePayment) {
        return '';
    }
    return serverPricing.singlePayment.price.amount;
};
export const serverPricingToClientCurrency = (serverPricing) => {
    return serverPricing?.singlePayment?.price?.currency || '';
};
export const getClientIsPriceEnabled = (pricing) => Boolean(pricing && pricing.singlePayment && pricing.singlePayment.price);
export const getChallengePaidPlans = (challengeId, userPaidPlans = []) => userPaidPlans.filter((plan) => (plan.challenges || []).includes(challengeId));
export const getChallengeVisiblePaidPlans = (challengeId, userPaidPlans = []) => {
    return (getChallengePaidPlans(challengeId, userPaidPlans) || []).filter(isPaidPlanActive);
};
export const isChallengeFree = (pricing, challengePaidPlansLength) => !((pricing && pricing.singlePayment) || challengePaidPlansLength);
export const isPaidPlanActive = (paidPlan) => {
    return paidPlan.visible !== false; // this weird check is needed
};
function getPaidPlansJoinedName(t, challengePaidPlans = [], joinedKey, forActivePlansOnly = false) {
    const plans = forActivePlansOnly
        ? challengePaidPlans.filter(isPaidPlanActive)
        : challengePaidPlans;
    if (!plans.length) {
        return '';
    }
    return plans.length === 1
        ? plans[0]?.details?.name || ''
        : t(joinedKey, {
            count: plans.length,
        });
}
export const serverToClientPricingV3 = (t, program, userPaidPlans = [], freeKey, separatorKey, joinedKey, hiddenPlansOnlyKey, ignoreHidden = false) => {
    const challengePricing = program?.price;
    const challengePaidPlans = getChallengePaidPlans(program?.id, userPaidPlans) || [];
    const isHasSinglePayment = !!challengePricing?.value;
    const isFree = !isHasSinglePayment && !challengePaidPlans.length;
    const isHiddenOnly = isHiddenPlansOnly(isHasSinglePayment, challengePaidPlans) && !ignoreHidden;
    if (isHiddenOnly) {
        return t(hiddenPlansOnlyKey);
    }
    if (isFree) {
        return t(freeKey);
    }
    const singlePayment = isHasSinglePayment
        ? serverPricingToClientPriceAndCurrencyStringV3(challengePricing)
        : null;
    const plansJoinedName = getPaidPlansJoinedName(t, challengePaidPlans, joinedKey, !ignoreHidden);
    return isHasSinglePayment && plansJoinedName
        ? `${singlePayment} ${t(separatorKey)} ${plansJoinedName}`
        : singlePayment || plansJoinedName || '';
};
export const serverToClientPricing = (t, challenge, userPaidPlans = [], freeKey, separatorKey, joinedKey, hiddenPlansOnlyKey, ignoreHidden = false) => {
    const challengePricing = challenge?.settings?.pricing;
    const challengePaidPlans = getChallengePaidPlans(challenge?.id, userPaidPlans) || [];
    const isFree = isChallengeFree(challengePricing, challengePaidPlans.length);
    const isHasSinglePayment = !!challengePricing?.singlePayment;
    const isHiddenOnly = isHiddenPlansOnly(isHasSinglePayment, challengePaidPlans) && !ignoreHidden;
    if (isHiddenOnly) {
        return t(hiddenPlansOnlyKey);
    }
    if (isFree) {
        return t(freeKey);
    }
    const singlePayment = isHasSinglePayment
        ? serverPricingToClientPriceAndCurrencyString(challengePricing)
        : null;
    const plansJoinedName = getPaidPlansJoinedName(t, challengePaidPlans, joinedKey, !ignoreHidden);
    return isHasSinglePayment && plansJoinedName
        ? `${singlePayment} ${t(separatorKey)} ${plansJoinedName}`
        : singlePayment || plansJoinedName || '';
};
//# sourceMappingURL=price.js.map